/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module to handle formatting for all types of numbers.
 * @module utilities/formats/numbers
 */
"use strict";

var _ = require("lodash");

// FIXME: Migrate to
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
var accounting = require("accounting-js");

// FIXME: Get these from an external source of truth, like:
// http://www.currency-iso.org/dam/downloads/lists/list_one.xml
// or:
// https://github.com/wiredmax/world-currencies
var defaultSettings = {
  currency: {
    decimal: ".",
    format: "%s %v",
    precision: 2,
    thousand: ","
  },
  number: {
    decimal: ".",
    precision: 0,
    thousand: ","
  }
};

var currencySettings = {
  AUD: {
    currency: {
      symbol: "AU$"
    }
  },
  CAD: {
    currency: {
      symbol: "CAD$"
    }
  },
  EUR: {
    currency: {
      symbol: "€"
    }
  },
  GBP: {
    currency: {
      symbol: "£"
    }
  },
  INR: {
    currency: {
      precision: 0,
      symbol: "₹"
    }
  },
  JPY: {
    currency: {
      precision: 0,
      symbol: "¥"
    }
  },
  USD: {
    currency: {
      symbol: "US$"
    }
  }
};

/**
 * Returns accounting settings based on locale.
 * @param  {string}  locale Locale to return accounting settings for.
 * @return {string}         Formatted string.
 */
function getAccountingSettings(locale) {
  var settings = currencySettings[locale] || locale && currencySettings[locale.toUpperCase()] || currencySettings.USD;

  return _.defaultsDeep({}, settings, defaultSettings);
}

/**
 * Format an amount of money to a string based on locale.
 * @param  {object}  options Options object.
 * @return {string}          Formatted string.
 */
function formatMoney(options) {
  return accounting.formatMoney(options.amount, options.settings || getAccountingSettings(options.locale).currency);
}

/**
 * Format a number to a string based on locale.
 * @param  {object}  options Options object.
 * @return {string}          Formatted string.
 */
function formatNumber(options) {
  return accounting.formatNumber(options.number, options.settings || getAccountingSettings(options.locale).number);
}

/**
 * Format a list of numbers to a string based on locale.
 * @param  {object}  options Options object.
 * @return {string}          Formatted string.
 */
function formatColumn(options) {
  return accounting.formatColumn(options.list, options.settings || getAccountingSettings(options.locale).number);
}

/**
 * Rounds a number to the correct amount of decimal places.
 * @param  {object}  options Options object.
 * @return {string}          Formatted string.
 */
function toFixed(options) {
  return accounting.toFixed(options.number, options.precision || defaultSettings.number.precision);
}

module.exports = exports = {
  formatColumn: formatColumn,
  formatMoney: formatMoney,
  formatNumber: formatNumber,
  getAccountingSettings: getAccountingSettings,
  toFixed: toFixed
};


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/formats/number.js
// module id = 872
// module chunks = 6